import { PermissionsV2 } from '@goparrot/users-v2-sdk';

export const PROMOTION_MODULE_READ_PERMISSIONS = [
  PermissionsV2?.PROMOTION.API_READ,
  PermissionsV2?.CUSTOMER.API_READ,
  PermissionsV2?.MERCHANT_MENU_MANAGEMENT.API_READ,
];

export const LOYALTY_MODULE_READ_PERMISSIONS = [PermissionsV2?.MERCHANT.LOYALTY_PAGE_VIEW, PermissionsV2?.PROMOTION.API_READ, PermissionsV2?.LOYALTY.API_READ];
